export interface DocumentType {
  label: string;
  value: string;
  icon: string;
  // Two-sided documents (e.g. driver's licenses) require both a front and a back image.
  twoSided?: boolean;
}

export const individualCustomerDocumentTypes: DocumentType[] = [
  { label: 'Passport', value: 'passport', icon: 'passport' },
  { label: "Driver's License", value: 'driving-license', icon: 'driver-license', twoSided: true },
  { label: 'National ID Card', value: 'id-card', icon: 'passport' },
  { label: 'Residence Permit', value: 'residence-permit', icon: 'document' },
  { label: 'Other', value: 'other', icon: 'document' },
];

export const businessCustomerDocumentTypes: DocumentType[] = [
  { label: 'Formation', value: 'formation', icon: 'company' },
  { label: 'Tax', value: 'tax', icon: 'accounting' },
  { label: 'Ownership', value: 'ownership', icon: 'businessman' },
  { label: 'Other', value: 'other', icon: 'document' },
];
